export default {
  superDesktop: 'Reports',
  addProductsToPurchase: 'Add products to purchase',
  appNotifications: 'App notifications',
  home: 'Home',
  peopleDirectory: 'Leads',
  peopleList: 'Lists',
  listDetails: 'List Details',
  roles: 'Tags',
  conversations: 'Conversations',
  conversationMetrics: 'Conversations metrics',
  conversationSettings: 'Conversations settings',
  businesses: 'Companies',
  businessDetails: 'Business details',
  campaigns: 'Campaigns',
  newSms: 'New SMS',
  newCampaign: 'New campaign',
  campaignDetails: 'Campaign Details',
  triggers: 'Triggers',
  notifications: 'Notifications',
  speechToText: 'Speech to text projects',
  authenticator: 'Authenticator',
  forms: 'Forms',
  upToDateNotifications: 'You are up to date with your notifications',
  /* events */
  events: 'Events',
  eventDetail: 'Event Detail',
  assistants: 'Assistants',
  promotors: 'Promotors',
  djs: 'Djs',
  products: 'Products',
  places: 'Places',
  productsSales: 'Products Purchases',
  /* ORDERS */
  clients: 'Clients',
  colors: 'Colors',
  containerTypes: 'Container Types',
  purchases: 'Purchases',
  purchaseDetail: 'Purchase Detail',
  sellers: 'Sellers',
  suppliers: 'Suppliers',
  /* END ORDERS */
  settings: 'Settings',
  details: 'Details',
  administrators: 'Users',
  billing: 'Billing',
  payments: 'Payments',
  creditCards: 'Credit Cards',
  newApp: 'New application',
  newCompany: 'New Company',
  newPage: 'New Page',
  servicesPerPage: 'Services per page',
  balance: 'Balance',
  loadingTariffs: 'loading Tariffs',
  noTariffsOnTheListYet: 'No Tariffs on the list yet',
  shortenLink: 'Shorten link',
  addCreditCart: 'Add credit card',
  addCard: 'Add card',
  load: 'Load',
  changePassword: 'Change password',
  exit: 'Exit',
  support: 'Support',
  /* TOOLBAR CARD */
  services: 'Services',
  value: 'Value',
  addCreditCard: 'Add credit card',
  createAplication: 'Create aplication'
}
